import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';

import { onGetLocalFromUtc } from '@utils/Util';

const HistoryPopup = ({ setSelectedRowId, sampleDetails }) => {
	return (
		<ModalContainer onCloseModal={() => setSelectedRowId(null)} className="update-history-modal">
			<div className="popup-wrapper">
				<div className="common-popup update-history-modal shadow-lg">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">ID & Status History</h3>
						</div>
						<div className="close-btn" onClick={() => setSelectedRowId(null)}>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
						</div>
					</div>
					<div className="common-popup-body">
						<div className="history-content">
							<div className="history-single">
								<div className="mb-12">
									<p className="regular-14 gray_dark_02 weight-500">
										First time sample ID inputed by:
									</p>
									<p className="regular-14 gray_dark_02">
										{sampleDetails?.sampleInventoryLocationAddedBy?.name}{' '}
										{onGetLocalFromUtc(
											sampleDetails?.sampleInventoryLocationAddedAt,
											'DD MMM, YYYY [at] hh:mm A'
										)}
									</p>
								</div>

								<div className="mb-12">
									<p className="regular-14 gray_dark_02 weight-500">
										Sample ID last updated by:
									</p>
									<p className="regular-14 gray_dark_02">
										{sampleDetails?.sampleStatusUpdatedBy?.name}{' '}
										{onGetLocalFromUtc(
											sampleDetails?.sampleStatusUpdatedAt,
											'DD MMM, YYYY [at] hh:mm A'
										)}
									</p>
								</div>
							</div>

							<div className="history-single">
								<div className="mb-12">
									<p className="regular-14 gray_dark_02 weight-500">
										Sample status last updated by:
									</p>
									<p className="regular-14 gray_dark_02">
										{' '}
										{sampleDetails?.sampleStatusUpdatedBy?.name}{' '}
										{onGetLocalFromUtc(
											sampleDetails?.sampleStatusUpdatedAt,
											'DD MMM, YYYY [at] hh:mm A'
										)}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

const TableActionDropdown = ({ rowId, selectedRowId, setSelectedRowId, onWrongEntry, sampleDetails }) => {
	return (
		<div className="edit-items">
			<div className="option">
				<div className="dropdown">
					<button
						className="btn btn-default dropdown-toggle"
						type="button"
						id={`menu-${rowId}`}
						data-toggle="dropdown"
						aria-expanded="false"
					>
						<img src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`} alt="tee" />
					</button>

					<ul
						className="dropdown-menu dropdown-menu-right shadow-lg"
						role="menu"
						aria-labelledby={`menu-${rowId}`}
						x-placement="top-end"
					>
						{sampleDetails?.id && (
							<li
								role="presentation"
								className="px-4 pb-3 pt-3"
								onClick={() =>
									sampleDetails?.sampleId &&
									onWrongEntry(
										sampleDetails?.id,
										sampleDetails?.isWrongEntry ? false : true
									)
								}
							>
								<a role="menuitem" tabIndex="-1" className="font-weight-normal  text-black">
									{sampleDetails?.isWrongEntry ? 'Make a Right Entry' : 'Wrong Entry'}
								</a>
							</li>
						)}

						<li role="presentation" className="px-4 pb-3" onClick={() => setSelectedRowId(rowId)}>
							<a className="font-weight-normal  text-black">History</a>
						</li>
					</ul>
				</div>
				{rowId === selectedRowId && (
					<HistoryPopup
						setSelectedRowId={setSelectedRowId}
						title={rowId}
						sampleDetails={sampleDetails}
					/>
				)}
			</div>
		</div>
	);
};

export default TableActionDropdown;
